export default "__VITE_ASSET__ff123ad2__"